(() => {
  if (window.sentopiaBrandNavigation) return;
  window.sentopiaBrandNavigation = true;
  function init() {
    document.querySelectorAll('.sp-brand-section .sp-brand').forEach(root => {
      if (root.dataset.navigationReady) return;
      root.dataset.navigationReady = 'true';
      const rail = root.querySelector('.sp-brand__layout');
      const previous = root.querySelector('[data-brand-direction="-1"]');
      const next = root.querySelector('[data-brand-direction="1"]');
      const count = root.querySelector('.sp-brand__count');
      const mobile = matchMedia('(max-width: 767px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const lifecycle = new AbortController();
      const options = {signal: lifecycle.signal};
      const points = () => {
        const cards = [...rail.querySelectorAll('.sp-brand__banner,.sp-brand__item')];
        const origin = cards[0].getBoundingClientRect().left;
        return cards.map(card => Math.min(rail.scrollWidth - rail.clientWidth, card.getBoundingClientRect().left - origin));
      };
      const index = values => values.reduce((best, value, i) => Math.abs(value - rail.scrollLeft) < Math.abs(values[best] - rail.scrollLeft) ? i : best, 0);
      function update() {
        if (!mobile.matches) { rail.removeAttribute('tabindex'); return; }
        rail.tabIndex = 0;
        const values = points(), current = index(values);
        previous.disabled = current === 0;
        next.disabled = current === values.length - 1;
        count.textContent = `${current + 1} / ${values.length}`;
      }
      function move(direction) {
        const values = points(), target = Math.max(0, Math.min(values.length - 1, index(values) + direction));
        rail.scrollTo({left: values[target], behavior: reduced.matches ? 'instant' : 'smooth'});
      }
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-brand-direction]');
        if (button) move(Number(button.dataset.brandDirection));
      }, options);
      rail.addEventListener('scroll', update, {...options, passive: true});
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !mobile.matches || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      const resize = new ResizeObserver(update);
      resize.observe(rail);
      mobile.addEventListener('change', () => { rail.scrollLeft = 0; update(); }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) { resize.disconnect(); lifecycle.abort(); }
      }, options);
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
